export const isEndIndex = (items: any[], index: number): boolean => {
  return index === items.length - 1;
};
